import { useGetGameStoryPatternsQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Loads a game's story-pattern mix against a benchmark, scoped by the active
 * network / month selectors. The benchmark is another game (`targetGameId`), a
 * genre (`targetGenreId`), or — with neither — the game's own genre.
 */
export const useGameStoryPatterns = (gameId: string | null, targetGameId?: string | null, targetGenreId?: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetGameStoryPatternsQuery(
    {
      gameId: gameId ?? '',
      targetGameId: targetGameId ?? undefined,
      targetGenreId: targetGameId ? undefined : targetGenreId ?? undefined,
      networkId: networkId ?? undefined,
      month: month ?? undefined,
    },
    { skip: !gameId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
